import axios, { AxiosInstance } from 'axios'
import EnvConstants from 'app/services/core/config.service'

const client = axios.create({
  baseURL: EnvConstants.CKLA_URL,
  withCredentials: true,
})

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 404) {
      return Promise.reject(error)
    }
    if (error.response.status === 403) {
      // push() method should be used regardless TS error
      // https://amplify-education.atlassian.net/browse/NVIC-2159
      // @ts-ignore
      window.history.push(`${EnvConstants.HUB_URL}/403`)
    }
    if (error.response.status === 408) {
      // push() method should be used regardless TS error
      // https://amplify-education.atlassian.net/browse/NVIC-2159
      // @ts-ignore
      window.history.push(`${EnvConstants.HUB_URL}/408`)
    } else {
      // push() method should be used regardless TS error
      // https://amplify-education.atlassian.net/browse/NVIC-2159
      // @ts-ignore
      window.history.push(`${EnvConstants.HUB_URL}/500`)
    }
    return Promise.reject(error)
  }
)

export default class Http {
  private client: AxiosInstance

  constructor() {
    this.client = client
  }

  get(url: string, params = {}) {
    return this.sendRequest('get', url, params, {})
  }

  getData(url: string, params = {}) {
    return this.get(url, params).then(({ data }) => data)
  }

  post(url: string, params = {}, data = {}) {
    return this.sendRequest('post', url, params, data)
  }

  sendRequest(
    method: string,
    url: string,
    params: Record<string, unknown>,
    data: unknown
  ) {
    return this.client.request({
      method,
      url,
      params,
      data,
    })
  }
}
